const actionTypes = {
  PRINTER_SET_PRINTER: "PRINTER_SET_PRINTER"
};

export default actionTypes;
